/** Shared Tailwind class strings so the five platform tabs stay typographically identical. */
export const supportedVersionsClass = 'text-sm text-muted-foreground';
export const instructionsHeadingClass = 'text-sm font-medium';
export const instructionsListClass = 'list-decimal space-y-1.5 ps-5 text-sm';
export const sectionClass = 'space-y-2';
